// change according to the need

export const contactEmail = 'contact@textdistill.com';
export const findWordsKeywords = 10;
